import { Spin } from 'antd';

export function PageLoading() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-[var(--bg-primary)]">
      <Spin size="large" />
    </div>
  );
}
